import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickUnique from '@/components/brick_unique.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-square', 'text-red']
infos.front_classes = ['fas', 'fa-divide', 'text-white']
infos.name = 'unique'
infos.associated_class_name = 'AutomlUnique'
infos.editing_component_name = 'BrickUnique'
infos.editing_component = BrickUnique
infos.descriptions = {
	en: {
		short_tooltip_description: 'Unique',
		full_tooltip_description: 'Drops duplicate rows for a table',
		navbar_name: 'Unique',
	},
	fr: {
		short_tooltip_description: 'Unique',
		full_tooltip_description:
			"Dédoublonnage d'une table (i.e. des lignes de la table)",
		navbar_name: 'Unique',
	},
}
// infos.short_tooltip_description = 'unique_short_tooltip'
// infos.full_tooltip_description = 'unique_full_tooltip'
// infos.navbar_name = 'unique_navbar'
infos.background_color = 'red'

brick_registerer(infos)
